export const STATUS_COLORS = {
  SUBMITTED: 'bg-blue-100 text-blue-800',
  APPROVED: 'bg-green-100 text-green-800',
  REJECTED: 'bg-red-100 text-red-800',
  PENDING: 'bg-yellow-100 text-yellow-800',
};

export const ROLES = {
  SUPER_ADMIN: 'Super Admin',
  AC_ADMIN: 'AC Admin',
  VIEWER: 'Viewer',
};

export const PER_PAGE_OPTIONS = [25, 50, 100];
